import { Zap, Check, Loader2 } from "lucide-react";
import { useState } from "react";
import { Button } from "./ui/button";
import { money } from "../lib/api";

export function LightningRequests({ requests, isLender, onBuild, onApproveBuild }) {
  const [busyId, setBusyId] = useState(null);
  if (!requests) return null;
  if (requests.length === 0)
    return <p className="text-sm text-white/40 py-6 text-center" data-testid="lightning-requests-empty">No lightning requests yet.</p>;

  const handleApproveBuild = async (r) => {
    if (!onApproveBuild) return;
    setBusyId(r.id);
    try {
      await onApproveBuild(r);
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div className="space-y-3" data-testid="lightning-requests-list">
      {requests.map((r) => {
        const done = r.status === "fulfilled";
        const working = r.status === "working";
        return (
          <div
            key={r.id}
            data-testid={`lightning-request-${r.id}`}
            className={`rounded-2xl p-4 border ${done
              ? "border-emerald-400/30 bg-emerald-400/5"
              : working
                ? "border-[#FFD23F]/60 bg-[#FFD23F]/[0.08] mpl-lightning-glow"
                : "border-[#FFD23F]/40 bg-[#FFD23F]/[0.06] shadow-[0_0_20px_rgba(255,210,63,0.15)]"}`}
          >
            <div className="flex items-center justify-between gap-3 flex-wrap">
              <div className="min-w-0">
                <p className="font-semibold flex items-center gap-1.5">
                  <Zap className={`h-4 w-4 ${done ? "text-emerald-400" : "text-[#FFD23F]"}`} /> {money(r.offer_price)}
                </p>
                <p className="text-sm text-white/60 break-words">{r.address}</p>
                <p className="text-[11px] text-white/35 mt-0.5">Requested by {r.requested_by || "agent"} · {(r.created_at || "").slice(0, 10)}</p>
              </div>

              <div className="ml-auto flex items-center gap-2 flex-wrap justify-end">
                {done ? (
                  <span className="text-[10px] tracking-[0.12em] uppercase px-2 py-1 rounded-full border border-emerald-400/40 text-emerald-400 flex items-center gap-1" data-testid={`lightning-status-${r.id}`}>
                    <Check className="h-3 w-3" /> Approved
                  </span>
                ) : isLender ? (
                  <>
                    {working && (
                      <span className="text-[10px] tracking-[0.12em] uppercase px-2.5 py-1 rounded-full border border-[#FFD23F]/60 text-[#FFE480] flex items-center gap-1.5 mpl-lightning-glow" data-testid={`lightning-status-${r.id}`}>
                        <Zap className="h-3 w-3" /> You're on it
                      </span>
                    )}
                    <Button
                      onClick={() => (working ? onBuild(r) : handleApproveBuild(r))}
                      disabled={busyId === r.id}
                      data-testid={`lightning-build-${r.id}`}
                      className="h-9 rounded-lg px-4 font-bold text-black bg-gradient-to-r from-[#FFD23F] to-[#FF8A00] hover:brightness-110 text-xs">
                      {busyId === r.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <><Zap className="h-3.5 w-3.5 mr-1" /> {working ? "Create new approval" : "Approve & create new approval"}</>}
                    </Button>
                  </>
                ) : working ? (
                  <span className="text-[10px] tracking-[0.12em] uppercase px-2.5 py-1 rounded-full border border-[#FFD23F]/60 text-[#FFE480] flex items-center gap-1.5 mpl-lightning-glow" data-testid={`lightning-status-${r.id}`}>
                    <Zap className="h-3 w-3" /> Your lender is on it
                  </span>
                ) : (
                  <span className="text-[10px] tracking-[0.12em] uppercase px-2 py-1 rounded-full border border-[#FFD23F]/40 text-[#FFD23F]" data-testid={`lightning-status-${r.id}`}>Pending</span>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
